import React, { useState, useEffect } from "react";
import {
  Nav,
  NavLink,
  Bars,
  NavMenu,
  NavBtn,
  NavBtnLink,
} from "./NavbarElements";
import logonav from "../../images/logonav.svg";
import Sidebar from "../Sidebar";
import ContactFormModal from "./ContactFormModal";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    setIsScrolled(scrollTop > 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Nav isScrolled={isScrolled}>
        <NavLink exact to="/" activeClassName="active">
          <img
            src={logonav}
            alt="Logo"
            style={{ width: "120px", height: "auto" }}
          />
        </NavLink>
        <Bars onClick={toggleMenu} />
        <Sidebar isOpen={isOpen} toggleMenu={toggleMenu} />
        <NavMenu isOpen={isOpen}>
          <NavLink to="/inicio">Inicio</NavLink>
          <NavLink to="/sobre">Sobre</NavLink>
          <NavLink to="/servicos">Serviços</NavLink>
          <NavLink to="/portfolio">Portfólio</NavLink>
        </NavMenu>
        <NavBtn>
          <NavBtnLink to="/inicio" onClick={openModal}>
            Fale Conosco
          </NavBtnLink>
        </NavBtn>
      </Nav>
      <ContactFormModal  isOpen={isModalOpen} closeModal={closeModal} />
    </>
  );
};

export default Navbar;
